'use strict'

export const DEFAULT_OPTS = [
	'No Answer',
	'Dark',
	'Quiet',
	'Blinds Closed',
	'Blinds Open',
	'Dog(s) Barking',
	'Secure',
	'Callbox—No Answer',
	'Phone—No Answer',
	'Gated',
	'No Callbox',
	'Name not in callbox',
	'Callbox non-functional',
	'Lights On',
	'Music Playing',
	'Television On',
	'Footsteps',
	'Voices',
	'Other Noises',
	'Avoiding',
	'No access',
];
